import { ThemeConfig, GlobalToken } from "antd";

// Base theme tokens that are used across the application
export const baseThemeTokens: Partial<GlobalToken> = {
  borderRadius: 6,
  fontSize: 14,
  lineHeight: 1.5715,
  controlHeight: 32,
  padding: 16,
  margin: 16,
};

// Light theme configuration
export const lightTheme: ThemeConfig = {
  token: {
    ...baseThemeTokens,
    colorPrimary: "#1570EF",
    colorLink: "#175CD3",
    colorBgBase: "#f1f0ef",
    colorBgLayout: "#f2f4f8",
    colorBgElevated: "#fdfeff",
    colorBgContainer: "#ffffff",
    colorBgSpotlight: "#2D2E32",
    colorBgTextHover: "#E0E5F0",
    colorHighlight: "#d5dfef",
    colorText: "#101328",
    colorTextSecondary: "#444c64",
    colorTextLightSolid: "#E2E3E9",
    colorBorder: "#bcd",
    colorBorderSecondary: "#d7dce2",
    colorInfoActive: "#e2eeff",
    motionDurationFast: "0",
    motionDurationMid: "0",
    motionDurationSlow: "0",
  },
  components: {
    Button: {
      colorPrimary: "#1570EF",
      algorithm: true,
    },
    Card: {
      colorBgContainer: "#fdfeff",
      colorBorder: "#bcd",
    },
    Table: {
      colorBgContainer: "#fdfeff",
      colorBorder: "#bcd",
    },
    Modal: {
      colorBgElevated: "#fdfeff",
    },
    Drawer: {
      colorBgElevated: "#fdfeff",
    },
  },
};

// Dark theme configuration
export const darkTheme: ThemeConfig = {
  token: {
    ...baseThemeTokens,
    colorPrimary: "#88bbff",
    colorLink: "#88bbff",
    colorLinkHover: "#417ee5",
    //colorBgContainer: "#31313e", original
    colorBgContainer: "#21212e", //explore a darker theme
    colorBgElevated: "#21212e",
    colorBgLayout: "#393949",
    colorBgBase: "#4f5566",
    colorBgMask: "#21212ecc",
    colorBgSpotlight: "#393949",
    colorBgTextHover: "#4f5566",
    colorPrimaryBorder: "#113377",
    colorHighlight: "#6e6e9c",
    colorText: "#f0f0f8",
    colorTextLightSolid: "#E2E3E9",
    colorTextSecondary: "#b0b0b8",
    colorTextTertiary: "#a0a0a8",
    colorTextQuaternary: "#909098",
    colorBorder: "#668",
    colorBorderSecondary: "#446",
    colorInfoActive: "#e2eeff",
    motionDurationFast: "0",
    motionDurationMid: "0",
    motionDurationSlow: "0",
  },
  components: {
    Button: {
      colorPrimary: "#88bbff",
      algorithm: true,
    },
    Card: {
      colorBgContainer: "#21212e",
      colorBorder: "#668",
    },
    Table: {
      colorBgContainer: "#21212e",
      colorBorder: "#668",
    },
    Modal: {
      colorBgElevated: "#21212e",
    },
    Drawer: {
      colorBgElevated: "#21212e",
    },
  },
};

export function cssVar(name: string, defaultValue: string = "#AAA") {
  const isSSR = typeof window === "undefined";
  const isTest = process.env.NODE_ENV === "test";

  if (isTest || isSSR) return defaultValue;

  try {
    // Get the current theme from the root element's data-theme attribute
    const root = document.documentElement;
    const currentTheme = root.dataset.theme || "light";
    root.dataset.theme = currentTheme;
    const value = window.getComputedStyle(root).getPropertyValue(name).trim();
    if (value) return value;

    console.warn(
      `[cssVar] Missing value for "${name}" in theme "${currentTheme}"`
    );
  } catch (error) {
    console.error(`[cssVar] Failed to resolve "${name}":`, error);
  }
  return defaultValue;
}
